export const BackgroundGradient = () => {
  return (
    <div
      aria-hidden="true"
      className="absolute z-[-1] h-full w-full transform-gpu overflow-hidden blur-3xl"
    >
      <div
        className="mx-auto aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#f542dd] to-[#7816a6] opacity-70"
        style={{
          clipPath:
            'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)'
        }}
      />
    </div>
  )
}
